module.exports = __webpack_public_path__ + "static/media/haisibao.9b21f042.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/haisibao.png
// module id = 112
// module chunks = 6